import {MAIN_ROOM_ID} from './constants';
import type {Participant, ParticipantID, RoomID} from './types';

export const createParticipants = () => {
    const participants = new Map<RoomID, Map<ParticipantID, Participant>>([
        [MAIN_ROOM_ID, new Map()],
    ]);

    function get(roomID: RoomID): Map<ParticipantID, Participant> | undefined;
    function get(roomID: RoomID, uuid: ParticipantID): Participant | undefined;
    function get(roomID: RoomID, uuid?: ParticipantID) {
        if (!uuid) {
            return participants.get(roomID);
        }
        return participants.get(roomID)?.get(uuid);
    }
    const set = (roomID: RoomID, participant?: Participant) => {
        if (!participant) {
            participants.set(roomID, new Map());
            return;
        }
        const roomParticipants = participants.get(roomID);
        if (roomParticipants) {
            roomParticipants.set(participant.uuid, participant);
        } else {
            participants.set(
                roomID,
                new Map([[participant.uuid, participant]]),
            );
        }
    };

    const find = (
        roomId: RoomID,
        predicate: (participant: Participant) => boolean,
    ) => {
        const roomParticipants = participants.get(roomId);
        if (!roomParticipants) {
            return undefined;
        }
        for (const p of roomParticipants.values()) {
            if (predicate(p)) {
                return p;
            }
        }
        return undefined;
    };

    const remove = (roomID: RoomID, uuid?: ParticipantID) => {
        if (uuid) {
            return participants.get(roomID)?.delete(uuid);
        }
        return participants.delete(roomID);
    };
    const getAll = (roomID: RoomID) => {
        const list = participants.get(roomID);
        if (!list) {
            return [];
        }
        return Array.from(list.values());
    };
    return {
        get,
        set,
        get size() {
            return participants.size;
        },
        find,
        remove,
        getAll,
    };
};
